import React, { useEffect } from 'react';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
import { therapyTypes } from '../data/mockData';

const CoupleTherapyPage = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  // Get the couple therapy data
  const coupleTherapy = therapyTypes.find(therapy => therapy.id === 2);

  return (
    <div className="pt-32 pb-16">
      <div className="section-container">
        {/* Hero section */}
        <div className="flex flex-col lg:flex-row gap-12 mb-16">
          <motion.div 
            className="w-full lg:w-1/2"
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6 }}
          >
            <h1 className="text-3xl md:text-4xl font-bold text-sharon-dark-green mb-6">
              {coupleTherapy.title}
            </h1>
            <div className="text-lg text-sharon-gray mb-8 whitespace-pre-line">
              {coupleTherapy.fullDescription}
            </div>
            <div className="mt-8">
              <Link to="/" className="sharon-btn">
                חזרה לדף הבית
              </Link>
            </div>
          </motion.div>

          <motion.div 
            className="w-full lg:w-1/2"
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8, delay: 0.2 }}
          >
            <div className="rounded-lg overflow-hidden shadow-lg">
              <img 
                src={coupleTherapy.imageSrc} 
                alt={coupleTherapy.title} 
                className="w-full h-auto"
              />
            </div>
          </motion.div>
        </div>

        {/* Benefits section */}
        <motion.div
          className="mt-16"
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6, delay: 0.4 }}
        >
          <h2 className="text-2xl font-semibold text-sharon-dark-green mb-6">
            היתרונות של טיפול זוגי
          </h2>
          
          <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
            <div className="bg-white p-6 rounded-lg shadow-md">
              <h3 className="text-xl font-semibold text-sharon-dark-green mb-3">תקשורת משופרת</h3>
              <p className="text-sharon-gray">
                טיפול זוגי מסייע בפיתוח מיומנויות תקשורת אפקטיביות בין בני הזוג, לימוד הקשבה אמפתית, והבעת רגשות וצרכים באופן בונה.
              </p>
            </div>
            
            <div className="bg-white p-6 rounded-lg shadow-md">
              <h3 className="text-xl font-semibold text-sharon-dark-green mb-3">העמקת הקרבה והאינטימיות</h3>
              <p className="text-sharon-gray">
                הטיפול מסייע ביצירת חיבור רגשי עמוק יותר, שיפור האינטימיות על כל רבדיה, וחיזוק הקשר הזוגי.
              </p>
            </div>
            
            <div className="bg-white p-6 rounded-lg shadow-md">
              <h3 className="text-xl font-semibold text-sharon-dark-green mb-3">פתרון קונפליקטים</h3>
              <p className="text-sharon-gray">
                לימוד אסטרטגיות יעילות לפתרון מחלוקות, התמודדות בריאה עם חילוקי דעות, והפיכת קונפליקטים להזדמנויות לצמיחה.
              </p>
            </div>
            
            <div className="bg-white p-6 rounded-lg shadow-md">
              <h3 className="text-xl font-semibold text-sharon-dark-green mb-3">הבנה עמוקה יותר</h3>
              <p className="text-sharon-gray">
                פיתוח הבנה עמוקה יותר של הדינמיקה הזוגית, הכרת הצרכים והרגשות של בן/בת הזוג, והעמקת האמפתיה ההדדית.
              </p>
            </div>
          </div>
        </motion.div>

        {/* Approaches section */}
        <motion.div
          className="mt-16"
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6, delay: 0.6 }}
        >
          <h2 className="text-2xl font-semibold text-sharon-dark-green mb-6">
            גישות בטיפול זוגי
          </h2>
          
          <div className="space-y-6">
            <div className="bg-white p-6 rounded-lg shadow-md">
              <h3 className="text-xl font-semibold text-sharon-dark-green mb-3">טיפול זוגי ממוקד רגש (EFT)</h3>
              <p className="text-sharon-gray">
                גישה זו מתמקדת ברגשות ובצרכים שמתחת לדפוסי האינטראקציה בין בני הזוג. הטיפול מסייע בזיהוי ושינוי של מעגלים שליליים בקשר, ובניית אינטראקציה רגשית בטוחה יותר שמקדמת את הקשר.
              </p>
            </div>
            
            <div className="bg-white p-6 rounded-lg shadow-md">
              <h3 className="text-xl font-semibold text-sharon-dark-green mb-3">טיפול זוגי אינטגרטיבי</h3>
              <p className="text-sharon-gray">
                גישה המשלבת אלמנטים מגישות טיפוליות שונות, ומותאמת לצרכים הספציפיים של כל זוג. הטיפול מתמקד בהבנת הדינמיקה הזוגית, שיפור התקשורת, ופיתוח אסטרטגיות להתמודדות עם אתגרים.
              </p>
            </div>
            
            <div className="bg-white p-6 rounded-lg shadow-md">
              <h3 className="text-xl font-semibold text-sharon-dark-green mb-3">טיפול זוגי ממוקד פתרונות</h3>
              <p className="text-sharon-gray">
                גישה זו מתמקדת בהווה ובעתיד, ופחות בחקר העבר. הטיפול מסייע בזיהוי פתרונות קיימים, הגדרת מטרות ברורות, ובניית תוכנית מעשית לשיפור היחסים.
              </p>
            </div>
          </div>
        </motion.div>

        {/* Testimonials section */}
        <motion.div
          className="mt-16"
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6, delay: 0.8 }}
        >
          <h2 className="text-2xl font-semibold text-sharon-dark-green mb-6">
            מה אומרים עליי
          </h2>
          
          <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
            <div className="bg-sharon-light-green p-6 rounded-lg">
              <p className="text-sharon-gray mb-4">
                "הטיפול הזוגי עם שרון שינה את חיי הנישואין שלנו. למדנו להקשיב באמת אחד לשני, ולהבין את הצרכים העמוקים שמניעים אותנו. אנחנו אסירי תודה על ההזדמנות לבנות מחדש את הקשר שלנו."
              </p>
              <p className="text-sharon-dark-green font-medium">- דנה ואייל</p>
            </div>
            
            <div className="bg-sharon-light-green p-6 rounded-lg">
              <p className="text-sharon-gray mb-4">
                "הגענו לטיפול ברגע קריטי בזוגיות שלנו, כשכבר חשבנו שאין תקווה. שרון עזרה לנו לראות את המצב בפרספקטיבה חדשה, ולפתח כלים שעוזרים לנו עד היום להתמודד עם אתגרים."
              </p>
              <p className="text-sharon-dark-green font-medium">- יוסי ומיכל</p>
            </div>
          </div>
        </motion.div>

        {/* Contact CTA */}
        <motion.div
          className="mt-16 bg-sharon-light-green p-8 rounded-lg text-center"
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6, delay: 1 }}
        >
          <h2 className="text-2xl font-semibold text-sharon-dark-green mb-4">
            מוכנים לצעד ראשון לקראת זוגיות בריאה יותר?
          </h2>
          <p className="text-lg text-sharon-gray mb-6">
            צרו איתי קשר לקביעת פגישת היכרות, בה נוכל לשוחח על האתגרים שלכם ועל איך אוכל לסייע.
          </p>
          <div className="flex flex-col sm:flex-row items-center justify-center space-y-4 sm:space-y-0 sm:space-x-4 sm:space-x-reverse">
            <a
              href="tel:+972526507776"
              className="sharon-btn text-lg px-6 py-2 rounded-md"
            >
              התקשרו עכשיו: 0526507776
            </a>
            <a
              href="mailto:sharon.weisfeld@gmail.com"
              className="text-sharon-dark-green hover:text-sharon-green transition-colors duration-300 text-lg"
            >
              שלחו מייל
            </a>
          </div>
        </motion.div>
      </div>
    </div>
  );
};

export default CoupleTherapyPage;